import { AppSubdomains } from 'src/types/common';

export enum StaticFlags {
  EnableSignUp = 'ENABLE_SIGN_UP_PAGE',
  EnableSocialLogin = 'ENABLE_SOCIAL_LOGIN',
  EnableAddressChange = 'ENABLE_ADDRESS_CHANGE',
  LaunchNotifications = 'LAUNCH_NOTIFICATIONS',
  EnableDownloadBanner = 'ENABLE_DOWNLOAD_BANNER',
  EnableRecommendedCategories = 'ENABLE_RECOMMENDED_CATEGORIES',
}

export interface LaunchNotificationConfig {
  storeClosed: {
    title: string;
    description: string;
    nextOpenDescription?: string;
  };
  outOfCoverage: {
    title: string;
    description: string;
  };
}

export type BooleanFlags = Exclude<
  StaticFlags,
  StaticFlags.LaunchNotifications
>;

export type StaticFlagsValue = {
  [StaticFlags.EnableSignUp]: boolean;
  [StaticFlags.EnableSocialLogin]: boolean;
  [StaticFlags.EnableAddressChange]: boolean;
  [StaticFlags.LaunchNotifications]: LaunchNotificationConfig | null;
  [StaticFlags.EnableDownloadBanner]: boolean;
  [StaticFlags.EnableRecommendedCategories]: boolean;
};

export type StaticFlagsHookType = () => {
  [key in StaticFlags]: StaticFlagsValue[key];
};

export type FlagStrategy = 'enabled' | 'disabled';

export interface SubdomainFlagConfig {
  strategy: FlagStrategy;
  exceptions: BooleanFlags[];
}

export type FlagsConfig = {
  [key in AppSubdomains]: SubdomainFlagConfig;
};
